export default __webpack_public_path__ + "static/media/Watson.d866e895.jpg";